function MdxOrderVO(id, physician, product, orderNumber, orderName, inMedatex, insurer, mdxStatus) {

    this.id = id;
    this.physician = physician;
    this.product = product;
    this.orderNumber = orderNumber;
    this.orderName = orderName;
    this.inMedatex = inMedatex;
    this.insurer = insurer;
    this.mdxStatus = mdxStatus;

    var _typeContext = {
        product: MdxProductVO,
        physician: MdxUserVO,
        insurer: MdxInsurerVO
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
